import { render } from "./NotFound.vue?vue&type=template&id=b3d78db8"
const script = {}
script.render = render

export default script